<template>
  <section class="content">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-5 col-sm-12 col-xs-12">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Tên sản phẩm</label>
          <input type="text" class="form-control" v-model="filterData.name"
                 placeholder="Nhập tên sản phẩm ..."/>
        </div>
      </div>
      <div class="col-md-5 col-sm-12 col-xs-12">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Phương thức thanh toán</label>
          <multiselect
            v-model="selectedPaymentMethod"
            id="ajax2"
            label="name"
            track-by="code"
            placeholder="Chọn phương thức thanh toán..."
            open-direction="bottom"
            :options="paymentMethods"
            :multiple="false"
            :searchable="false"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="true"
            :options-limit="300"
            :limit="2"
            :max-height="600"
            :show-no-results="false"
            :hide-selected="false"
            :disabled="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-md-2 col-sm-12 col-xs-12">
        <div class="d-flex justify-content-between align-items-center">
          <b-button variant="warning" @click="search" style="margin-top: 26px">
            <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
          </b-button>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                 show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>
          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>
          <template v-slot:cell(id)="data">
            {{ genSeqId(data) }}
          </template>
          <template v-slot:cell(payment_method)="data">
            {{ getPaymentMethod(data.item.payment_method) }}
          </template>
          <template v-slot:cell(price)="data">
            {{ data.item.price | format_currency }}
          </template>
          <template v-slot:cell(period_fee)="data">
            {{ data.item.period_fee | format_currency }}
          </template>
          <template v-slot:cell(actions)="dataId">
            <b-button variant="success" v-b-tooltip.hover title="Chọn" @click="selectProduct(dataId.item)"><i
              class="fa fa-check"/></b-button>
          </template>

        </b-table>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import Multiselect from '../lib/vue-multiple-select/Multiselect'
import {mapGetters} from 'vuex'
import {debounce} from 'lodash'
import Utils from '../common/utils'
import {PAYMENT_METHOD} from '../common/constant'
import ProductAPI from '../api/product'
import CompanyAPI from '../api/company'

export default {
  name: 'ProductTable',
  components: {
    'va-box': VABox,
    Multiselect
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  props: {
    selectProductEvent: {
      type: Function,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      filterData: {
        name: '',
        payment_method: null,
        company_id: 0
      },
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'name',
          label: 'Tên sản phẩm',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'description',
          label: 'Mô tả sản phẩm',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'price',
          label: 'Giá tiền (vnđ)',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'payment_method',
          label: 'Phương thức thanh toán',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ],
      loading: false,
      selectedCompany: null,
      selectedPaymentMethod: null,
      loadingCompany: false,
      companies: [],
      paymentMethods: [],
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      debounceCompany: null,
      disableCompanyField: false,
      isEditable: true
    }
  },
  created () {
    this.debounceCompany = debounce(this.filterProduct.bind(this), 500)
  },
  mounted () {
    this.initCompany()
    this.initPaymentMethod()
    this.filter()
  },
  methods: {
    initCompany () {
      let company = Utils.getCompanyByUserInfo(this.userInfo)
      if (company) {
        this.disableCompanyField = true
        this.selectedCompany = {name: company.name, code: company.id}
      }
    },
    initPaymentMethod () {
      this.paymentMethods = Object.keys(PAYMENT_METHOD).map(
        key => {
          return {'name': PAYMENT_METHOD[key], 'code': key}
        }
      )
      if (this.type === 'NEW_BUY') {
        this.selectedPaymentMethod = {name: 'Thanh toán 1 lần', code: 'DEBIT'}
      } else {
        this.selectedPaymentMethod = {name: 'Thanh toán hàng tháng', code: 'CREDIT'}
      }
    },
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    calculateCompanyId () {
      this.filterData.company_id = this.selectedCompany ? this.selectedCompany.code : null
      const companyId = this.$route.query.company_id
      if (this.filterData.company_id == null && companyId) {
        this.filterData.company_id = companyId
      }
    },
    calculatePaymentMethod () {
      this.filterData.payment_method = this.selectedPaymentMethod ? this.selectedPaymentMethod.code : null
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.calculateCompanyId()
      this.calculatePaymentMethod()

      if (this.filterData.company_id === null) {
        this.items = []
        this.loading = false
        return
      }

      ProductAPI.filter(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterProduct (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    search () {
      if (this.selectedCompany == null) {
        this.items = []
        return
      }
      this.filter()
    },
    selectProduct (product) {
      this.selectProductEvent(product)
    },

    getPaymentMethod (paymentMethodKey) {
      return PAYMENT_METHOD[paymentMethodKey]
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductTable.vue